import React from 'react';
import I18n from 'i18n-js';

import { RCIcon } from '@reverbdotcom/cadence/components';
import AffirmLogo from '@reverbdotcom/cadence/images/vendor/affirm-logo.svg?component';

import SanitizedRender from './sanitized_render';
import AffirmLearnMoreModal from './affirm_learn_more_modal';

interface IProps {
  availableTermMonths: (number | null)[] | null;
  buyerPrice: string;
  estimatedMonthlyPayment: string;
  maxTermMonth: number;
  zeroPercentFinancing?: boolean;
  lowestAprAtMaxTerm?: number;
  splitPay?: boolean;
}

function AffirmEstimateCTA({
  availableTermMonths,
  buyerPrice,
  estimatedMonthlyPayment,
  maxTermMonth,
  zeroPercentFinancing = false,
  lowestAprAtMaxTerm = null,
  splitPay,
}: IProps) {

  if (!estimatedMonthlyPayment) { return null; }

  return (
    <div className="affirm-estimate-cta">
      <SanitizedRender
        className="affirm-estimate-cta__copy"
        html={
          I18n.t(splitPay ? 'commons.affirmEstimateCTA.splitPay' : 'commons.affirmEstimateCTA.asLowAsWith', {
            price: estimatedMonthlyPayment,
            tagOpen: '<strong>',
            tagClose: '</strong>',
          })
        }
      />
      <span className="affirm-estimate-cta__logo">
        <RCIcon
          svgComponent={AffirmLogo}
          title={I18n.t('commons.affirmEstimateCTA.affirmLogo')}
          inline
        />
      </span>
      {zeroPercentFinancing &&
        <span className="affirm-estimate-cta__zero-percent">
          {I18n.t('commons.affirmEstimateCTA.zeroPercent')}
        </span>
      }
      <div className="affirm-estimate-cta__learn-more">
        <AffirmLearnMoreModal
          estimatedMonthlyPayment={estimatedMonthlyPayment}
          buyerPrice={buyerPrice}
          maxTermMonth={maxTermMonth}
          availableTermMonths={availableTermMonths}
          zeroPercentFinancing={zeroPercentFinancing}
          lowestAprAtMaxTerm={lowestAprAtMaxTerm}
          splitPay={splitPay}
        />
      </div>
    </div>
  );
}

export default AffirmEstimateCTA;
